module.exports = __webpack_public_path__ + "img/axie.6da930dd.png";